module.exports = __webpack_public_path__ + "img/BAU Seniors_Infographics_34.f4d9b6f4.png";